<template>
  <div class="page-shell">
    <div class="page-header">
      <div>
        <p class="page-kicker">ADDRESS PARSER</p>
        <h2 class="page-title">地址解析</h2>
        <p class="page-subtitle">粘贴地址后提交，解析成功会按原格式复制到剪切板，并刷新下方记录。</p>
      </div>
    </div>

    <section class="resolver-panel glass-panel">
      <textarea
        class="hf-textarea input-address"
        placeholder="请粘贴地址，例如：张三 13800000000 广东省深圳市南山区..."
        v-model="infoAddress">
      </textarea>

      <div class="resolver-actions">
        <button
          class="hf-btn hf-btn--primary"
          type="button"
          :disabled="!infoAddress.trim()"
          @click="submitResolveAddress"
        >
          {{ submitting ? '解析中' : '提交解析' }}
        </button>
        <button class="hf-btn" type="button" @click="infoAddress = ''">清空</button>
      </div>
    </section>

    <ResolveAddressList ref="resolve"/>
  </div>
</template>

<script>
import ResolveAddressList from "@/components/ResolveAddressList.vue";
import {submitNlAnalysisLocation} from "@/api/ResolveAddress";

export default {
  name: 'ResolveAddress',
  components: {ResolveAddressList},
  data(){
    return  {
      infoAddress: '',
      submitting: false
    }
  },
  methods: {
    submitResolveAddress() {
      if (!this.infoAddress.trim()) {
        this.$message.warning('先粘贴一段地址');
        return;
      }

      this.submitting = true;
      submitNlAnalysisLocation({
        sourceLocationStr: this.infoAddress
      }).then(res => {
        if (res.data.isSuccess) {
          let copySuccess = this.copyToClipBoard(res.data)
          if (copySuccess) {
            this.$notify({
              title: '解析成功',
              message: '已复制到剪切板',
              type: 'success'
            });
          } else {
            this.$notify.error({
              title: '快捷复制失败',
              message: '请检查浏览器权限，或使用下方复制模式复制',
            });
          }
        } else {
          this.$notify.error({
            title: '解析失败',
            message: '请检查地址串；如收件人与地址连接在一起，需要在中间加一个空格',
          });
        }

        this.$refs.resolve.showAllUserInfo(1, 10)
      }).finally(() => {
        this.submitting = false;
      })
    },
    formattedDate(dateStr) {
      let date = new Date(dateStr);
      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },
    copyToClipBoard(data) {
      try {
        const str =
          this.formattedDate(data.createTime)
          + '\t' +
          (data.username ? data.username : '')
          + '\t' +
          (data.phone ? data.phone : '')
          + '\t' +
          '\t' +
          (data.province ? data.province : '')
          + '\t' +
          (data.city ? data.city : '')
          + '\t' +
          (data.district ? data.district : '')
          + '\t' +
          (data.detailLocation ? data.detailLocation : '')
          + '\t' +
          (data.recordUser ? data.recordUser : '')
          + '\r\n'
        navigator.clipboard.writeText(str);
        return true;
      } catch (err) {
        console.error('Failed to copy text: ', err);
        return false;
      }
    }
  }
}
</script>

<style scoped>
.resolver-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-radius: 18px;
  padding: 18px;
}

.input-address {
  min-height: 190px;
  font-size: 14px;
  line-height: 1.7;
}

.resolver-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
